import { PackageApi } from '../../../../api/Purchase/Package'
import AddPackage from '../../../../components/Purchasing/Packages/AddPackage/AddPackage'
import PackageModal from '../../../../components/Purchasing/Packages/AddPackage/PackageModal'
import useActions from '../../../../elements/Hooks/useActions'
import useModalData, { MODAL_TYPE_EDIT, MODAL_TYPE_NEW } from '../../../../elements/Hooks/useModalData'
import useTitle from '../../../../elements/Hooks/useTitle'
import { get } from 'lodash'
import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom'

AddPackageCont.propTypes = {}

function AddPackageCont (props) {
  const key = get(props, 'clicked.original._key') || get(props.match, 'params.key')
  const {
    visible,
    modalType,
    object: packageObj,
    setObject: setPackage,
    submitting,
    submit,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    update,
    fetching,
    fetchObject: fetch,
  } = useModalData(
    PackageApi.create,
    PackageApi.update,
    PackageApi.remove,
    undefined,
    key,
    PackageApi.read,
    undefined,
    () => {
      props.history.replace({
        pathname: `/purchasing/package/list/`,
      })
    },
  )

  useEffect(() => {
    console.log('effect', !!get(props, 'clicked.original._key'))
    if (!!get(props, 'clicked.original._key')) {
      console.log('in')
      onShow(props.clicked.original, 'edit')
    }
  }, [key])

  const {
    actions,
    fetchingActions,
    fetchActions,
    submittingOperation,
    submitOperation,
    handleActions,
  } = useActions('package', packageObj, setPackage, PackageApi.operation)

  const type = key ? MODAL_TYPE_EDIT : MODAL_TYPE_NEW
  const isNew = type === MODAL_TYPE_NEW

  useTitle(
    packageObj.code === undefined ? `Create New Package Order` : `${packageObj.code} Package Order`,
  )

  const isUpdatable = isNew ? true : actions.find(a => a.key === 'update')
  const isLocked = packageObj.locked
  const isConfirmed = ['Confirmed'].includes(packageObj.status)

  const passProps = {
    ...{
      type,
      visible,
      isLocked,
      modalType,
      packageObj,
      submitting,
      isConfirmed,
      submit,
      removing,
      remove,
      formRef,
      onShow,
      onCancel,
      update,
      isNew,
      actions,
      fetchingActions,
      fetchActions,
      submittingOperation,
      submitOperation,
      handleActions,
      fetching,
      fetch,
      isUpdatable,
    },
  }
  return get(props, 'clicked.original._key') ? (
    <PackageModal {...passProps} />
  ) : (
    <AddPackage {...passProps} />
  )
}

export default withRouter(AddPackageCont)
